export const IMAGE_ORIGINAL = 'IMAGE_ORIGINAL';
export const IMAGE_CORRECTED = 'IMAGE_CORRECTED';
export const IMAGE_OUTLINE = 'IMAGE_OUTLINE';
export const IMAGE_SHADE_MAP = 'IMAGE_SHADE_MAP';
export const IMAGE_MODIFIER = 'IMAGE_MODIFIER';
export const IMAGE_TRIPLE_VIEW = 'IMAGE_TRIPLE_VIEW';
export const IMAGE_DOUBLE_VIEW = 'IMAGE_DOUBLE_VIEW';

